var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"12"}},[_c('MediaViewer',{attrs:{"targetPath":_vm.path,"view":'grid'},on:{"route-update":_vm.updateRoute}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }